"use client";

/**
 * Empty-state body for a report section that is built in the design but
 * deliberately out of scope this pass — Executive summary and Sources
 * (plan §"Out of scope", §9 #12).
 *
 * No direct design source: the design ships both sections in full. This uses
 * the design's `.rv-card` geometry with a dashed border so it reads as a frame
 * waiting on data rather than a finished card, and the `.rv-eyebrow` /
 * `.rv-intro` type scale from `compass-oppreport.jsx`.
 */

export interface ReportSectionPlaceholderProps {
  title: string;
  /** One sentence naming what will live here and what blocks it. */
  message: string;
}

/** Dashed `.rv-card` carrying an eyebrow title and one explanatory sentence. */
export function ReportSectionPlaceholder({
  title,
  message,
}: ReportSectionPlaceholderProps) {
  return (
    <div
      className={[
        "bg-(--bg-canvas) border border-dashed border-(--border-default)",
        "rounded-(--radius-container) p-[18px] mb-3",
      ].join(" ")}
    >
      <div
        className={[
          "text-[10.5px] tracking-[0.1em] uppercase",
          "font-bold text-(--fg-muted)",
        ].join(" ")}
      >
        {title}
      </div>
      <p className="m-0 mt-2 text-[14px] leading-[1.6] text-(--fg-secondary)">
        {message}
      </p>
    </div>
  );
}
